// Introducing the method of registering components
import { withInstall } from '@/utils';
// Introducing Components
import backTop from './backTop.vue';
// Throw component
export const BackTop = withInstall(backTop, 'BackTop');
